"use client"

import HomeDetailsWrapperAccordion from "@/features/homeowners/components/home-details-wrapper-accordion"
import { useWorkscopeLabelStyle, WORKSCOPE_LABEL_COLORS } from "../home-details-wrapper-accordion"
import FormSelectInput from "../../../../shared/components/form-inputs/form-select-input"
import FormMultiSelectInput from "../../../../shared/components/form-inputs/form-multi-select-input"
import { workScopeStatusOptions } from "../../constants/options"
import FormTextareaInput from "../../../../shared/components/form-inputs/form-textarea-input"
import DateStampedTextarea from "../../../../shared/components/form-inputs/form-date-stamped-textarea-input"
import FormTextInput from "@/shared/components/form-inputs/form-text-input"
import { HomeWithHomeOwnerFormType } from "../../schema/home-with-home-owner.schema"
import { useFormContext, useWatch } from "react-hook-form"
import { useClaimedByOptions } from "../../hooks/use-claimed-by-options"
import { useWorkscopeClaimedBySync } from "../../hooks/use-workscope-claimed-by-sync"
import { GoodwillToggleLabel } from "../goodwill-toggle-label"

const goodwillGreenStyle = { color: WORKSCOPE_LABEL_COLORS.goodwill } as const
const BASE_FIELD_NAME = "home.bathroomRebuildInfo"

function HomeBathroomRebuildForm() {
    const goodwillLabelStyle = useWorkscopeLabelStyle(true) ?? goodwillGreenStyle
    const { control, setValue, getValues } = useFormContext<HomeWithHomeOwnerFormType>()
    const { options: claimedByOptions, loading: claimedByLoading } = useClaimedByOptions()
    const goodwillBathroomRebuildOn = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillBathroomRebuildOn` })
    
    // Watch status field and claimed by field
    const bathroomRebuild = useWatch({ control, name: `${BASE_FIELD_NAME}.bathroomRebuild` })
    const claimedBy = useWatch({ control, name: `${BASE_FIELD_NAME}.claimedBy` })
    const goodwillBathroomRebuild = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillBathroomRebuild` })
    const goodwillBathroomRebuildClaimedBy = useWatch({
        control,
        name: `${BASE_FIELD_NAME}.goodwillBathroomRebuildClaimedBy`,
    })

    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: bathroomRebuild,
        claimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.claimedBy`,
        setValue,
        getValues,
    })
    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: goodwillBathroomRebuild,
        claimedBy: goodwillBathroomRebuildClaimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.goodwillBathroomRebuildClaimedBy`,
        setValue,
        getValues,
        enabled: !!goodwillBathroomRebuildOn,
    })
    return (
        <HomeDetailsWrapperAccordion
            heading="Bathroom Rebuild"
            wrapperClassName="xl:grid-cols-2"
        >
            <FormSelectInput
                inputGroupProps={{
                    label: <GoodwillToggleLabel title="Bathroom Rebuild" toggleName={`${BASE_FIELD_NAME}.goodwillBathroomRebuildOn` as any} control={control} />,
                }}
                options={workScopeStatusOptions}
                name={`${BASE_FIELD_NAME}.bathroomRebuild`}
                control={control}
            />
            <FormMultiSelectInput
                inputGroupProps={{
                    label: "Claimed By",
                }}
                options={claimedByOptions}
                name={`${BASE_FIELD_NAME}.claimedBy`}
                control={control}
                placeholder={claimedByLoading ? "Loading options..." : "Select"}
                searchPlaceholder="Search options..."
            />
            {goodwillBathroomRebuildOn && (
                <>
                    <FormSelectInput
                        inputGroupProps={{ label: "Bathroom Rebuild Goodwill", labelStyle: goodwillLabelStyle }}
                        options={workScopeStatusOptions}
                        name={`${BASE_FIELD_NAME}.goodwillBathroomRebuild`}
                        control={control}
                    />
                    <FormMultiSelectInput
                        inputGroupProps={{ label: "Bathroom Rebuild Goodwill Claimed By" }}
                        options={claimedByOptions}
                        name={`${BASE_FIELD_NAME}.goodwillBathroomRebuildClaimedBy`}
                        control={control}
                        placeholder={claimedByLoading ? "Loading options..." : "Select"}
                        searchPlaceholder="Search options..."
                    />
                </>
            )}
            <FormTextInput
                inputGroupProps={{
                    label: "How many bathroom vanities needed?",
                }}
                type={"number"}
                placeholder="How many bathroom vanities needed?"
                name={`${BASE_FIELD_NAME}.bathroomVanities`}
                control={control}
            />
            <DateStampedTextarea
                includeUserName
                inputGroupProps={{
                    label: "Add any other detail you can about the bathroom rebuild and cabinet needs",
                    wrapperClassName: "xl:col-span-2"
                }}
                rows={4}
                name={`${BASE_FIELD_NAME}.description`}
                control={control}
            />
        </HomeDetailsWrapperAccordion>
    )
}

export default HomeBathroomRebuildForm 
